export default "__VITE_ASSET__Dqgus0eR__"